import { CancelBookingSuccessPage } from '@/app/pages/booking/cancellation/cancel-booking-success';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/booking/cancellation/success')({
  component: CancelBookingSuccessPage,
  validateSearch: z.object({
    hasPrePayment: z.boolean(),
    isFull: z.boolean(),
  }),
  loaderDeps: ({ search }) => ({
    hasPrePayment: search.hasPrePayment,
  }),
});
